const data = [
    "widget_logo",
    // "symbol_info", //商品信息对话框
    // "timezone_men", //商品信息对话框禁用时区上下文菜单
    // "go_to_date", //前往到（选时间段）
    // "compare_symbol", //菜单中删除“比较/覆盖”对话框
    // "left_toolbar", //左侧工具栏
    // "pane_context_menu", //图标右键菜单
    "volume_force_overlay", //在主数据列的同一窗格上放置成交量指示器  防止他们重叠
    // "pane_context_menu",
    // "contextmenu",
    // "scales_context_menu",
    // "legend_context_menu",
    // "display_market_status",
    // "timeframes_toolbar", //底部时间栏
    // "snapshot_trading_drawings", //包含屏幕截图中的订单/位置/执行信号
    "use_localstorage_for_settings", //允许将用户设置保存到localstorage
    // "header_undo_redo", //头部左右箭头
    "header_compare", //头部对比信息按钮
    // "header_settings", //设置按钮
    "header_resolutions", //时间选择、分时切换
    // "header_screenshot", //截图相机
    // 'header_chart_type',// k线样式
    // 'property_pages',// 禁用所有属性页
    // "header_saveload",
    // "control_bar",//与图表底部的导航按钮相关联
    // "legend_widget",// 禁用此功能会隐藏图例窗口小部件
    // "header_layouttoggle",//显示标题中的“选择布局”按钮
    // "header_fullscreen_button", //全屏按钮
    // "header_indicators", //指标
    // "header_chart_type",//图表类型切换
    'header_symbol_search', // 头部搜索
    // "symbol_search_hot_key",
    // "header_widget",//隐藏头部的组件dom
    // "header_widget_dom_node", // 隐藏头部组件
    // "header_interval_dialog_button",
    // "show_interval_dialog_on_key_press",
    // "snapshot_trading_drawings",
]


export default data;